import {
  ClaimAssetValidationSchema,
  ClaimCategorySchema,
  SelectorAttributes,
} from '@lunit-io/ctl-data-server';

import { ClaimAssetCreateSchema } from 'src/types/api/data/project';
import { AssetTemplateFormSchema } from 'src/types/client/asset';

const checkValidity = (
  claimAssets: ClaimAssetCreateSchema[],
  validations?: ClaimAssetValidationSchema
): boolean => {
  const assetNames = claimAssets.map(({ name }) => name);

  if (!validations) {
    return true;
  }

  return Object.keys(validations).every(key => {
    // TODO : Need to eliminate the "[key: string]: unknown" from the type definition.
    //
    // It would be the best if we can normalize these logics but
    // the ClaimAssetValidationSchema is auto-generated to have
    // "[key: string]: unknown" for the last field of it, so
    // the only way to avoid "unknown" type is handling the fixed key
    // "ifSet" and "oneOf" directly.
    switch (key) {
      case 'ifSet': {
        const validation = validations[key];
        const selectedAsset = claimAssets.find(
          ({ name }) => name === validation.name
        );
        // Validate whether the selected asset is in a project or not.
        if (!selectedAsset) {
          return false;
        }
        // Validate whether the selected values are in a selected asset or not.
        const stringifiedSelectedAsset = JSON.stringify(selectedAsset);
        return validation.selectedValues?.every(value => {
          // If the value is boolean, that means that asset is a toggler type.
          // The toggler type asset is not describing the available values like the selector asset,
          // so it is okay to pass only by checking the type of the value.
          if (typeof value === 'boolean') {
            return true;
          } else {
            return stringifiedSelectedAsset.indexOf(value) > -1;
          }
        });
      }
      case 'oneOf': {
        // Validate whether the selected assets are in a project or not.
        const values = validations[key];
        return values.every(value => assetNames.includes(value.name));
      }
      default: {
        return true;
      }
    }
  });
};

const getCategories = (
  asset: AssetTemplateFormSchema
): ClaimCategorySchema[] => {
  if (asset.form !== 'selector') {
    return [];
  }
  return (asset.formAttributes as SelectorAttributes)?.categories || [];
};

const AssetValidationUtils = Object.freeze({
  checkValidity,
  getCategories,
});

export default AssetValidationUtils;
